import _ from 'underscore';
import templateStr from 'text!./templates/wizard-sidebar-additional.html';

export default ['ModalService', 'qnb.EmailService', '$q', 'StateUtils', '$state', '$translate', 'EventHub', '$window', function (ModalService, QuoteEmailService, $q, StateUtils, $state, $translate, EventHub, $window) {
    return {
        restrict: 'A',
        template: templateStr,
        link: function link(scope) {
            scope.quoteNumber = function () {
                var flowModel = StateUtils.activeDataForState(true).flowModel;
                if (!flowModel) {
                    return null;
                }
                var submission = flowModel.snapshot.value;
                return submission ? submission.quoteID : null;
            };

            scope.printQuote = function () {
                EventHub.publish('wizard', 'print');

                $window.print();
            };

            scope.emailQuote = function () {
                var submission = StateUtils.activeDataForState(true).flowModel.snapshot.value;
                var acctHolder = _.findWhere(submission.persons, {
                    accountHolder: true
                });
                var emailInfo = {
                    quoteID: submission.quoteID,
                    sessionID: submission.sessionUUID
                };

                $q.when(QuoteEmailService.emailQuote(emailInfo), function () {
                    ModalService.showInfo('quoteandbind.directives.QnbWizardButtons.Quote Emailed', $translate('quoteandbind.directives.QnbWizardButtons.The quote details have been emailed', {
                        emailAddress: acctHolder.emailAddress1
                    }));
                }, function () {
                    ModalService.showError('quoteandbind.directives.QnbWizardButtons.Error', 'quoteandbind.directives.QnbWizardButtons.Sorry, we were not able to email the quote details at this time.');
                });
            };

            scope.submissionCreated = function () {
                var flowModel = StateUtils.activeDataForState(true).flowModel;
                if (flowModel && flowModel.snapshot) {
                    var submission = flowModel.snapshot.value;
                    return submission.submissionExists() && submission.baseData.accountHolder.emailAddress1;
                }
            };
        }
    };
}];


//////////////////
// WEBPACK FOOTER
// ./app/customer/js/src/edge/quoteandbind/common/directives/WizardSidebarAdditional.js
// module id = 855
// module chunks = 0